import { render, staticRenderFns } from "./WalletFamilyTable.vue?vue&type=template&id=33cc9bd0"
import script from "./WalletFamilyTable.vue?vue&type=script&lang=js"
export * from "./WalletFamilyTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports